module.exports = __webpack_public_path__ + "static/img/5areaA_11.5da6fd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_11.png
// module id = 812
// module chunks = 1